export function shallowDiffers(a, b) {
  return !Object
    .keys(a)
    .every((key) => a[key] === b[key]);
}
